import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigProvider } from '../config/config';
import { RequestProvider } from '../request/request';
import { ResultTIme } from '../result/result';
import { SessionProvider } from '../session/session';
import areas from '../../assets/data/area/area';
import { StorageProvider } from '../storage-service/storage-service';
/*
  Generated class for the EventProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/


@Injectable()
export class PaymentProvider {
    constructor(public request: RequestProvider) { }


    async makeIntent(params): Promise<any> {
        let url = "http://localhost:3000/payment/" + params.paymentMethodType + "/" + params.amount + "/" + params.currency;

        return this.request.getApiOwnPath<any>(url);
    }

}